import React from 'react';
import { Heart, Instagram, Twitter, Mail, ArrowUp, MessageCircle } from 'lucide-react';
import { siteData } from '../data/mock';

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-950 text-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-vibrant-blue/10 rounded-full blur-3xl opacity-20" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-vibrant-purple/10 rounded-full blur-3xl opacity-20" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="space-y-6">
            <a href="#home" className="flex items-center gap-2 group">
              <span className="font-bold text-2xl tracking-tight text-white font-outfit">
                Wed<span className="text-vibrant-red">Labs</span>
              </span>
            </a>
            <p className="text-slate-400 leading-relaxed text-sm max-w-xs">
              Crafting beautiful digital experiences for your special day. Make your wedding invitation as unique as your love story.
            </p>
            <div className="flex gap-4">
              <a href={siteData.founder.social.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-vibrant-purple hover:text-white transition-all">
                <Instagram className="w-5 h-5" />
              </a>
              <a href={siteData.founder.social.twitter} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-vibrant-blue hover:text-white transition-all">
                <Twitter className="w-5 h-5" />
              </a>
              <a href={`https://wa.me/${siteData.whatsappNumber}`} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-vibrant-green hover:text-white transition-all">
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold font-outfit mb-6">Quick Links</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              {siteData.navLinks.slice(0, 4).map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="hover:text-vibrant-blue transition-colors flex items-center gap-2">
                    <ArrowUp className="w-3 h-3 rotate-90 opacity-0 group-hover:opacity-100 transition-opacity" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-bold font-outfit mb-6">Legal</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Terms of Service</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Cookie Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Refund Policy</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold font-outfit mb-6">Contact Us</h4>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-vibrant-purple flex-shrink-0 mt-0.5" />
                <span>{siteData.contactEmail}</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 text-vibrant-green flex-shrink-0 mt-0.5 text-center font-bold">W</div>
                <span>{siteData.whatsappNumber}</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 text-vibrant-red flex-shrink-0 mt-0.5 text-center font-bold">L</div>
                <span>Ahmedabad, Gujarat,<br />India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
          <p>
            © {new Date().getFullYear()} WedLabs. All rights reserved.
          </p>
          <div className="flex items-center gap-1">
            <span>Made with</span>
            <Heart className="w-4 h-4 text-vibrant-red fill-current animate-pulse" />
            <span>in India</span>
          </div>

          <button
            onClick={scrollToTop}
            className="fixed bottom-8 right-8 p-3 rounded-full bg-vibrant-blue text-white shadow-lg shadow-vibrant-blue/30 hover:-translate-y-1 transition-all z-40 hidden md:block"
          >
            <ArrowUp className="w-5 h-5" />
          </button>
        </div>
      </div>
    </footer>
  );
};
